module.exports = __webpack_public_path__ + "static/media/water bill_1.9605ead8.png";